import { useAuth } from '@/context/CoginitoAuthProvider';
import { LocalStorageService } from '@/utils/LocalStorage';

/**
 * KB resolvers need two headers, not one:
 *  - `Authorization` carries the tenant API key and gates the resolver. It is
 *    set once on the HttpLink, so every operation already has it.
 *  - `identity` carries the Cognito ID token, which is the token actually
 *    verified. Without it the resolver answers `Unauthorized: Invalid token`.
 */
export const useKbAuth = () => {
  const { session } = useAuth();

  const identityToken = session
    ? session.getIdToken().getJwtToken()
    : LocalStorageService.getItem('idToken');

  const kbContext = (fetchOptions?: RequestInit) => ({
    headers: { identity: identityToken },
    ...(fetchOptions ? { fetchOptions } : {}),
  });

  return { identityToken, kbContext };
};
